import { Box, Typography } from "@mui/material";
import { Button } from "@/components/atoms";

export interface ErrorStateProps {
  errors: string;
}

export const ErrorState = ({ errors }: ErrorStateProps) => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Box
      data-testid="error-state"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        gap: 2,
      }}
    >
      <Typography color="error.main" variant="h4" align="center">
        Error loading data: {errors}
      </Typography>
      <Button
        componentName={"error-state"}
        variant="contained"
        color="primary"
        onClick={handleGoBack}
      >
        Go Back
      </Button>
    </Box>
  );
};
